import { BryntumGanttProjectModel } from '@bryntum/gantt-react';

/**
 * In 6.x BryntumGantt destroys the shared ProjectModel on its own unmount,
 * which runs before this wrapper's componentWillUnmount. The base wrapper
 * then calls destroy() again on the already-destroyed instance, producing
 * "me.doDestroy is not a function". Skip the redundant destroy.
 */
export class GanttProjectModel extends BryntumGanttProjectModel {
    componentWillUnmount(): void {
        const instance = this.instance as
            | (BryntumGanttProjectModel['instance'] & { isDestroyed?: boolean; isDestroying?: boolean })
            | undefined;

        if (!instance || instance.isDestroyed || instance.isDestroying) {
            return;
        }

        try {
            instance.destroy();
        } catch {
            // Swallow: a sibling Gantt may have torn the project down between
            // our isDestroyed check and the destroy call.
        }
    }
}
